import { NgModule } from '@angular/core';
import { MomentModule } from 'ngx-moment';
import { CommonModule } from '@angular/common';
import { AgGridAngular } from 'ag-grid-angular';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { DirectivesModule } from '../../../components/directives.module';
import { OutgoingComponent } from './outgoing.component';

const ROUTES: Routes = [
  { path: '', component: OutgoingComponent, pathMatch: 'full' },
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    DirectivesModule,
    MomentModule,
    RouterModule.forChild(ROUTES),
    AgGridAngular,
  ],
  declarations: [OutgoingComponent],
  exports: [OutgoingComponent],
})

export class OutgoingModule {}
